import React from "react";
import { Nav, Navbar, Container, Button, Offcanvas } from "react-bootstrap";

const WEBSITE_URL = "https://denttrack.co.uk";
const ACADEMY_URL = "https://academy.denttrack.co.uk";

const Header = ({ minimal = false }) => {
  return (
    <div>
      <Navbar bg="white" expand="lg" className="text-capitalize fw-bold mb-3">
        <Container>
          <Navbar.Brand href={`${process.env.PUBLIC_URL}/`}>
            <img
              src={`${process.env.PUBLIC_URL}/images/logo.png`}
              width=""
              height=""
              className="d-inline-block logo"
              alt={process.env.REACT_APP_APPNAME}
            />
          </Navbar.Brand>
          {!minimal && <Navbar.Toggle aria-controls="website-offcanvas-nav" />}
          {!minimal && <Navbar.Offcanvas
            id="website-offcanvas-nav"
            aria-labelledby="website-offcanvas-nav-label"
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="website-offcanvas-nav-label">
                Menu
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="ms-lg-auto align-items-lg-center">
                <Nav.Link className="px-3" href={`${WEBSITE_URL}/product-services`}>
                  Product &amp; Services
                </Nav.Link>
                <Nav.Link className="px-3" href={`${WEBSITE_URL}/pricing`}>
                  Pricing
                </Nav.Link>
                <Nav.Link className="px-3" href={`${WEBSITE_URL}/contact-us`}>
                  Contact Us
                </Nav.Link>
                <Nav.Link className="px-3" href={ACADEMY_URL} target="_blank" rel="noreferrer">
                  Denttrack Academy
                </Nav.Link>
                <Nav.Link className="px-3" href={`${WEBSITE_URL}/reviews`}>
                  Reviews
                </Nav.Link>
                <Nav.Link className="px-3" href={`${WEBSITE_URL}/blogs`}>
                  Blogs
                </Nav.Link>
                <Nav.Link className="px-3" href={`${WEBSITE_URL}/team`}>
                  Team
                </Nav.Link>
                <Nav.Link className="px-3" href={`${WEBSITE_URL}/faqs`}>
                  FAQs
                </Nav.Link>
                <Nav.Link className="px-3" href={`${WEBSITE_URL}/resources`}>
                  Resources
                </Nav.Link>
                <Button
                  variant="primary"
                  className="px-4 ms-lg-2 mt-2 mt-lg-0"
                  href={`${process.env.PUBLIC_URL}/login`}
                >
                  Login
                </Button>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>}
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
